export const FETCH_ADD_DOCUMENTS_REQUEST = 'FETCH_ADD_DOCUMENTS_REQUEST'
export const FETCH_ADD_DOCUMENTS_SUCCESS = 'FETCH_ADD_DOCUMENTS_SUCCESS'
export const FETCH_ADD_DOCUMENTS_FALUIRE = 'FETCH_ADD_DOCUMENTS_FALUIRE'
